import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalculator } from '@fortawesome/pro-solid-svg-icons/faCalculator';
import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';
import { HotkeyDisplayService } from '../../services/hotkey-display-service';
import { SCAN_TO_VIEW } from '../../../components/hotkeys/constants/barcodes';
import { ScanToViewTooltip } from './tooltips/scan-to-view';
import { FEATURE_ROUTE_SCAN } from '../../../components/app-header/constants/routes';

import style from './display-tooltip.module.less';

export const HotkeyDisplayTooltip = () => {
  const [hotkeyPressed, setHotkeyPressed] = useState(null);
  const zIndex = useMaxZ();
  const zIndexStyle = useMemo(() => ({ zIndex }), [zIndex]);
  const location = useLocation();
  useEffect(() => {
    const unsubscribeHotkeyService = HotkeyDisplayService.subscribe(() => {
      const keysPressed = HotkeyDisplayService.getHotkeys();
      setHotkeyPressed(Object.values(keysPressed)[0] || null);
    });
    return unsubscribeHotkeyService;
  }, []);

  if (hotkeyPressed?.barcode === SCAN_TO_VIEW && location.pathname !== FEATURE_ROUTE_SCAN) {
    return <ScanToViewTooltip />;
  }
  if (!hotkeyPressed?.hotkey) {
    return null;
  }
  return hotkeyPressed.isCustomPreset ? (
    <div className={style['tooltip-wrapper']} style={zIndexStyle}>
      <FontAwesomeIcon className={style['display-icon']} icon={faCalculator} />
      <span className={style['hotkeys-pressed']}>{hotkeyPressed.name}:</span>
      <b>{hotkeyPressed.presetName}</b>
    </div>
  ) : (
    <div className={style['tooltip-wrapper']} style={zIndexStyle}>
      <FontAwesomeIcon className={style['display-icon']} icon={faCalculator} />
      <span className={style['hotkeys-pressed']}>{hotkeyPressed.hotkey.join(' then ')}:</span>
      <b>{hotkeyPressed.name}</b>
    </div>
  );
};
